import mixpanel from 'mixpanel-browser'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

mixpanel.init('92263f9c2393d7dab5b93d182bd32b15', { debug: true, track_pageview: true, persistence: 'localStorage', ignore_dnt: true })
const urlParams = new URLSearchParams(window.location.search);
const distinctId = urlParams.get('distinct_id');
console.log('distinct ID', urlParams, distinctId, distinctId?.replace('$device:', ''))
console.log("mixpanel distinct id before", mixpanel.get_distinct_id())
mixpanel.track('test-onb-before-identify')
mixpanel.identify(distinctId?.replace('$device:', ''))
console.log("mixpanel distinct id after", mixpanel.get_distinct_id())
mixpanel.track('test-onb-after-identify')

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
